import { TaskFieldOption, WorkflowTask } from '../../../models';
import {
  TaskFieldOptionsResponse,
  Task as OctopusTask,
  KeyAndDisplay,
} from '../models';
import { ConfigurationMapper } from './configuration';

export class TaskFieldOptionsMapper extends ConfigurationMapper<
  TaskFieldOptionsResponse,
  TaskFieldOption
> {
  from(source: TaskFieldOptionsResponse): TaskFieldOption {
    const task = source.Task?.FieldOptions;

    return {
      priority: task?.Priority?.map(this.mapKeyAndDisplay) ?? [],
      category: task?.Category?.map(this.mapKeyAndDisplay) ?? [],
      result: task?.Result?.map(this.mapKeyAndDisplay) ?? [],
      assignedTo: task?.AssignedTo?.map(this.mapKeyAndDisplay) ?? [],
    };
  }
}

export class WorkflowTaskMapper extends ConfigurationMapper<
  OctopusTask[],
  WorkflowTask[]
> {
  from(source: OctopusTask[]): WorkflowTask[] {
    return source.map(
      (item) =>
        ({
          key: item.Key,
          activity: item.Activity ?? null,
          dateTime: item.DateTime.Value,
          completionDate: item.CompletionDate?.Value ?? '',
          assignedTo: item.AssignedTo
            ? this.mapKeyAndDisplay(item.AssignedTo)
            : null,
          abEntry: item.AbEntry
            ? {
                ...this.mapKeyAndDisplay(item.AbEntry as KeyAndDisplay),
                type: item.AbEntry.Type,
              }
            : null,
          workflowInstanceKey: item.WorkflowInstanceKey ?? null,
          workflowTaskTemplateKey: item.WorkflowTaskTemplateKey ?? null,
          priority: item.Priority ?? null,
          completed: item.Completed ?? false,
        }) as WorkflowTask,
    );
  }
}
